import type { DocEntry } from "@manifest/schema.ts";

interface Props {
  doc: DocEntry;
  onSelect: (doc: DocEntry) => void;
  index?: number;
}

export function DocCard({ doc, onSelect, index }: Props) {
  const cap = (BigInt(doc.ckbfs.capacity) / 100_000_000n).toString();
  return (
    <button
      type="button"
      onClick={() => onSelect(doc)}
      className="group w-full text-left flex items-start gap-4 px-4 py-3 border-b border-parchment-400/40 hover:bg-parchment-200/40 hover:border-parchment-400/80 transition-colors"
    >
      {index !== undefined && (
        <span className="font-serif text-xl text-parchment-700 group-hover:text-parchment-900 tabular-nums leading-none pt-1 transition-colors">
          {String(index).padStart(2, "0")}
        </span>
      )}
      <span className="flex-1">
        <span className="block font-serif text-xl text-parchment-900 leading-snug">
          {doc.title}
        </span>
        <span className="block mt-1 font-mono text-[10px] uppercase tracking-[0.12em] text-parchment-600">
          {doc.id} <span className="text-parchment-400">·</span> v{doc.version}{" "}
          <span className="text-parchment-400">·</span> {cap} CKB
        </span>
      </span>
      <span className="font-serif text-2xl text-parchment-400 group-hover:text-parchment-700 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all leading-none pt-1">
        →
      </span>
    </button>
  );
}
